export const AuthDefaultState = () => {
  return {
    accessToken: null,
    refreshToken: null,
    user: null,
    userDetails: null,
    selectedPos: null,
    posList: null,
    userPhones: null,
    overflow: 'auto',
    accountType: null,
    afterLogin: false,
    loginState: {
      data: {},
      fetching: false,
      error: null,
    },
  };
};
